export type ApiErrorPayload = {
  code: string
  message: string
  resourceType?: string
  resourceId?: string
  technicalReason?: string
  recommendedAction?: string
  correctionTarget?: string
  correlationId?: string
  details?: unknown
}

export type Page<T> = {
  items: T[]
  page: number
  pageSize: number
  totalItems: number
  totalPages: number
}

export class ApiError extends Error {
  readonly status: number
  readonly code: string
  readonly resourceType?: string
  readonly resourceId?: string
  readonly technicalReason?: string
  readonly recommendedAction?: string
  readonly correctionTarget?: string
  readonly correlationId?: string
  readonly details?: unknown

  constructor(status: number, payload: ApiErrorPayload) {
    super(payload.message)
    this.name = 'ApiError'
    this.status = status
    this.code = payload.code
    this.resourceType = payload.resourceType
    this.resourceId = payload.resourceId
    this.technicalReason = payload.technicalReason
    this.recommendedAction = payload.recommendedAction
    this.correctionTarget = payload.correctionTarget
    this.correlationId = payload.correlationId
    this.details = payload.details
  }
}
